/**
 * STORIES PROTECT — Lógica de widget
 * Archivo: assets/stories-protect.js
 */

(function () {
  const SP_PRODUCT_ID = 9218931392738;
  let isAdding = false;

  // ─── CONECTAR BOTONES ────────────────────────────────────────────
  function connectButtons() {
    document.querySelectorAll('[data-sp-add]').forEach(function(btn) {
      if (btn._spBound) return;
      btn._spBound = true;
      btn.addEventListener('click', function() {
        var widget    = btn.closest('.stories-protect-widget');
        var variantId = parseInt(widget.dataset.variantId);
        var label     = widget.dataset.label;
        storiesProtectAdd(variantId, label, btn);
      });
    });

    document.querySelectorAll('[data-sp-remove]').forEach(function(btn) {
      if (btn._spBound) return;
      btn._spBound = true;
      btn.addEventListener('click', storiesProtectRemove);
    });
  }

  // ─── AGREGAR ─────────────────────────────────────────────────────
  async function storiesProtectAdd(variantId, label, btn) {
    if (isAdding || !variantId) return;
    isAdding = true;

    if (btn) {
      btn.disabled  = true;
      btn.innerHTML = '<span class="sp-spinner"></span> Agregando...';
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Error al agregar');
      }

      window.location.reload();

    } catch (e) {
      console.error('[StoriesProtect] Error al agregar:', e);
      if (btn) {
        btn.disabled  = false;
        btn.innerHTML =
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>' +
          'Agregar protección · ' + (label || '');
      }
    } finally {
      isAdding = false;
    }
  }

  // Exponer globalmente por compatibilidad
  window.storiesProtectAdd = storiesProtectAdd;

  // ─── QUITAR ──────────────────────────────────────────────────────
  async function storiesProtectRemove() {
    try {
      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();
      const item    = cart.items.find(function(i) {
        return i.product_id === SP_PRODUCT_ID;
      });
      if (!item) return;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });

      window.location.reload();

    } catch (e) {
      console.error('[StoriesProtect] Error al quitar:', e);
    }
  }

  window.storiesProtectRemove = storiesProtectRemove;

  // ─── INIT ────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectButtons);
  } else {
    connectButtons();
  }

  // Reconectar cuando el drawer inyecta el widget en el DOM
  new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (
          (node.classList && node.classList.contains('stories-protect-widget')) ||
          (node.querySelector && node.querySelector('.stories-protect-widget'))
        ) {
          connectButtons();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

})();